import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { SessionStorageService } from 'ngx-webstorage';
import jwt_decode from 'jwt-decode';
import { environment } from "@environment/environment";

/* ************************************************************************** */
// Declarar o HttpClientModule e o providers apenas no app.module
/* ************************************************************************** */


@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor(
    private sessionStorage: SessionStorageService,
  ) { }




  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!request.url.includes("http"))
      return next.handle(request);

    const agentId = this.sessionStorage.retrieve('agentId');
    const agentLang = this.sessionStorage.retrieve('agentLang');
    const userToken = this.sessionStorage.retrieve('userToken');
    const platformToken = this.sessionStorage.retrieve('platformToken');
    const tenantId = location.hostname.split(".")[0].toUpperCase();


    let userId = "0";
    let claims_hash = "-1";
    let newReq: HttpRequest<any>;


    if (userToken) {
      const decoded: any = jwt_decode(userToken);
      userId = decoded[environment.jwt.aud].user_id.toString() || "";
      claims_hash = decoded[environment.jwt.aud].claims_hash.toString() || "";
    }

    newReq = request.clone({
      setHeaders: {
        "x-tenant-id": tenantId,
        "x-agent-id": agentId,
        "x-agent-lang": agentLang,
        "x-user-id": userId,
        "x-user-claims": claims_hash,
        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Access-Control-Allow-Origin': '*',
      }
    });

    //if (platformToken !== null && platformToken !== ""){
    if (userToken !== null && userToken !== ""){
      
      newReq = request.clone({
        setHeaders: {
          "x-tenant-id": tenantId,
          "x-agent-id": agentId,
          "x-agent-lang": agentLang,
          "x-user-id": userId,
          "x-user-claims": claims_hash,
          'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
          'Pragma': 'no-cache',
          'Expires': '0',
          'Access-Control-Allow-Origin': '*',
          'Authorization': `Bearer ${userToken}`
        }
      });

    }

    return next.handle(newReq);
  }
}
